import React, { memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// NOTE: memoized because SVG icons are surprisingly expensive to re-render and WILL make the UI sluggish!
export default memo(function Icon(props) {

    let className = '';
    if (props.className) {
        className = props.className;
    } else if (props.onClick) {
        className = 'text-primary cursorPointer';
    }

    if (props.disabled) {
        className += ' disabled-opacity';
        className = className.replace('cursorPointer', '');
    }

    return (
        <FontAwesomeIcon
            className={ className }
            onClick={ props.disabled ? () => {
            } : props.onClick }
            icon={ props.icon }
            size={ props.size }
            color={ props.color }
            disabled={ props.disabled }
            fixedWidth={ props.fixedWidth }
        />
    );
});
